import { animate, group, query, style } from '@angular/animations';

export const SlideInOutAnimation = [
  style({ height: '!' }),
  query(':enter', style({ transform: 'translateX(100%)', opacity: 0 }), {
    optional: true
  }),
  query(':enter, :leave', style({ position: 'absolute', top: 0, left: 0, right: 0 }), { optional: true }),
  // animate the leave page away
  group([
    query(':leave', [animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(-100%)', opacity: 0 }))], { optional: true }),
    // and now reveal the enter
    query(':enter', animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(0)', opacity: 1 })), { optional: true })
  ])
];

export const SelfSlideInOutAnimation = [
  style({ height: '!' }),
  query(':self', style({ transform: 'translateX(100%)', opacity: 0 }), {
    optional: true
  }),
  query(':self, :leave', style({ position: 'absolute', top: 0, left: 0, right: 0 }), { optional: true }),
  // animate the leave page away
  group([
    query(':leave', [animate('100.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(-100%)', opacity: 0 }))], {
      optional: true
    }),
    // and now reveal the self
    query(':self', animate('100.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(0)', opacity: 1 })), { optional: true })
  ])
];

export const FadeInOutAnimation = [
  style({ height: '!' }),
  query(':self', animate('0.3s cubic-bezier(.35,0,.25,1)', style({ opacity: 0 })), {
    optional: true
  }),
  query(':self', animate('0.3s cubic-bezier(.35,0,.25,1)', style({ opacity: 1 })), {
    optional: true
  })
];
